import React, { useState, useEffect } from 'react'
import gsap from 'gsap'

function Marquee() {
  const [marqueeContent, setMarqueeContent] = useState('')

  useEffect(() => {
    const fetchMarqueeContent = async () => {
      try {
        const response = await fetch('/wp-json/wp/v2/pages?slug=marquee')
        const data = await response.json()
        
        if (data[0]) {
          setMarqueeContent(data[0].content.rendered)
        }
      } catch (error) {
        console.error('Marquee content fetch error:', error)
      }
    }

    fetchMarqueeContent()
  }, [])

  useEffect(() => {
    if (marqueeContent) {
      gsap.to('.marquee-content', {
        xPercent: -50,
        repeat: -1,
        duration: 15,
        ease: 'none'
      })
    }
  }, [marqueeContent])

  if (!marqueeContent) return null

  return (
    <div className="marquee-container">
      <div className="marquee-wrapper">
        {/* Repeat the content multiple times for better coverage */}
        <div className="marquee-content" dangerouslySetInnerHTML={{ __html: marqueeContent }} />
        <div className="marquee-content" dangerouslySetInnerHTML={{ __html: marqueeContent }} />
        <div className="marquee-content" dangerouslySetInnerHTML={{ __html: marqueeContent }} />
        <div className="marquee-content" dangerouslySetInnerHTML={{ __html: marqueeContent }} />
      </div>
    </div>
  )
}

export default Marquee

